<template>
  <div>
    <UserManualMenu/>
  </div>
</template>

<script>
import UserManualMenu from "@/components/menuadmin/usermanual/menuusermanual/UserManualMenu";
export default {
  name: "UserManual",
  components: {
    UserManualMenu
  }
}
</script>

<style scoped>

</style>
